import React from 'react';
import style from './FAQFreshdesk.module.css';
import { FAQ } from '@/components/FAQ/FAQ';
import { FAQFreshdeskList } from './FAQFreshdeskList';
import { Container } from '@/components/Containers/Container';
import { Typography } from '@/components/Typography/Typography';

type FAQFreshdeskProps = {
  isMobile: boolean;
};
export const FAQFreshdesk = ({ isMobile }: FAQFreshdeskProps) => {
  return (
    <section className="relative">
      <Container className="md:py-24.5-vw py-15 md:w-10/12">
        <div className="flex flex-col items-center gap-5">
          <Typography as="h2" $type="Heading1" className="font-formula">
            Frequently asked questions
          </Typography>
          <FAQ isMobile={isMobile} list={FAQFreshdeskList} className={style.faq} />
        </div>
      </Container>
    </section>
  );
};
